/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'dashboard': {
    width: 16,
    height: 16,
    viewBox: '0 0 100 100',
    data: '<path pid="0" d="M54.168 63.25V41.668c0-2.3-1.867-4.168-4.168-4.168s-4.168 1.867-4.168 4.168V63.25A12.501 12.501 0 1062.32 77.148a12.503 12.503 0 00-8.153-13.898zM50 79.168a4.165 4.165 0 01-3.848-2.574 4.158 4.158 0 01.903-4.54 4.158 4.158 0 014.539-.902A4.165 4.165 0 0154.168 75c0 1.106-.441 2.164-1.223 2.945s-1.84 1.223-2.945 1.223zM100 62.5a4.166 4.166 0 11-8.332 0 41.667 41.667 0 00-62.5-36.086A41.666 41.666 0 008.332 62.5 4.166 4.166 0 110 62.5a50 50 0 01100 0z"/>'
  }
})
